import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }, null, -1)
const _hoisted_8 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_9 = { "aria-label": "breadcrumb" }
const _hoisted_10 = { class: "breadcrumb mb-0" }
const _hoisted_11 = { class: "breadcrumb-item" }
const _hoisted_12 = { href: "#" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" }, null, -1)
const _hoisted_14 = { class: "breadcrumb-item" }
const _hoisted_15 = { href: "javascript:void(0)" }
const _hoisted_16 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "text-md-right" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_20 = { class: "modal-body" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_22 = {
  key: 2,
  class: "card"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "payer-email-list-display" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode()
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "col-md-6 text-md-right" }
const _hoisted_31 = { class: "my-2" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-2" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "members-list pt-0"
}
const _hoisted_34 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_35 = { class: "more-member" }
const _hoisted_36 = { class: "row my-4" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_40 = { class: "desc-wrap" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_43 = { class: "desc-wrap" }
const _hoisted_44 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, "Total Project Days:", -1)
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_47 = { class: "desc-wrap" }
const _hoisted_48 = /*#__PURE__*/_createVNode("p", null, "Project Timeline", -1)
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createVNode("strong", null, "TBD", -1)
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_56 = {
  key: 2,
  class: "inline-items my-3"
}
const _hoisted_57 = { key: 3 }
const _hoisted_58 = { key: 4 }
const _hoisted_59 = { class: "mt-4" }
const _hoisted_60 = { class: "row align-items-center mb-2" }
const _hoisted_61 = { class: "col-sm-6" }
const _hoisted_62 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_63 = { class: "row my-1" }
const _hoisted_64 = { class: "col-md-3" }
const _hoisted_65 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_67 = { class: "desc-wrap" }
const _hoisted_68 = { class: "col-md-4" }
const _hoisted_69 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_70 = { class: "desc-wrap" }
const _hoisted_71 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, "No. of days for this phase", -1)
const _hoisted_72 = { class: "col-md-4" }
const _hoisted_73 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_74 = { class: "desc-wrap" }
const _hoisted_75 = /*#__PURE__*/_createVNode("p", null, "Phase Timeline", -1)
const _hoisted_76 = { key: 0 }
const _hoisted_77 = /*#__PURE__*/_createVNode("strong", null, "TBD", -1)
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { key: 2 }
const _hoisted_80 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_81 = { class: "col-md-3" }
const _hoisted_82 = {
  key: 0,
  class: "members-list pt-0 mt-2"
}
const _hoisted_83 = { class: "mt-4" }
const _hoisted_84 = {
  key: 0,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_85 = { class: "row align-items-center mb-2" }
const _hoisted_86 = { class: "col-sm-6" }
const _hoisted_87 = { class: "form-check form-check-inline mb-2" }
const _hoisted_88 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_89 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_90 = { class: "members-list pt-sm-0 text-sm-right" }
const _hoisted_91 = { class: "row my-1" }
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_94 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_95 = { class: "desc-wrap" }
const _hoisted_96 = { class: "row mt-2 align-items-start" }
const _hoisted_97 = { class: "col-md-5" }
const _hoisted_98 = { class: "col-md-4" }
const _hoisted_99 = { class: "iconed-holder d-flex align-items-center" }
const _hoisted_100 = { class: "desc-wrap" }
const _hoisted_101 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, [
  /*#__PURE__*/_createVNode("strong", null, "No. of days for this task:")
], -1)
const _hoisted_102 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_103 = { class: "form-check mt-2" }
const _hoisted_104 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "excludeWeekends"
}, " Exclude Weekends ", -1)
const _hoisted_105 = { class: "mt-2" }
const _hoisted_106 = {
  key: 0,
  class: "list-accordion mt-2"
}
const _hoisted_107 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_108 = { class: "mb-0" }
const _hoisted_109 = { class: "card-body p-2" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-md-6" }
const _hoisted_112 = { class: "col-md-6" }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = {
  key: 2,
  class: "image-in-chat preview-image-list"
}
const _hoisted_115 = { class: "row mx-n2" }
const _hoisted_116 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_117 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_118 = { class: "sr-only" }
const _hoisted_119 = { class: "imaged-col" }
const _hoisted_120 = { class: "small-img-wrap" }
const _hoisted_121 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_122 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_123 = { class: "sr-only" }
const _hoisted_124 = { class: "imaged-col" }
const _hoisted_125 = { class: "small-img-wrap" }
const _hoisted_126 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_127 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_128 = { class: "sr-only" }
const _hoisted_129 = { class: "imaged-col" }
const _hoisted_130 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_131 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_132 = { class: "centered-wrap" }
const _hoisted_133 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_134 = { class: "sr-only" }
const _hoisted_135 = { class: "card d-block mt-3" }
const _hoisted_136 = { class: "card-head pb-3" }
const _hoisted_137 = { class: "card-title" }
const _hoisted_138 = { class: "row mx-n2" }
const _hoisted_139 = { class: "col-md-4 px-2" }
const _hoisted_140 = { class: "shadowed-card bg-light mt-2" }
const _hoisted_141 = { class: "mb-3" }
const _hoisted_142 = {
  "data-toggle": "modal",
  "data-target": "#documentModal",
  class: "btn default-btn me-2"
}
const _hoisted_143 = { class: "col-md-4 px-2" }
const _hoisted_144 = { class: "shadowed-card bg-light mt-2" }
const _hoisted_145 = { class: "mb-3" }
const _hoisted_146 = {
  "data-toggle": "modal",
  "data-target": "#documentModal1",
  class: "btn default-btn me-2"
}
const _hoisted_147 = { class: "inline-items mt-3" }
const _hoisted_148 = { class: "mr-3" }
const _hoisted_149 = { class: "signature-wrap" }
const _hoisted_150 = { class: "signature-wrap" }
const _hoisted_151 = { class: "form-group" }
const _hoisted_152 = { for: "" }
const _hoisted_153 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_154 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_155 = { class: "form-group" }
const _hoisted_156 = { class: "inline-items" }
const _hoisted_157 = { class: "upload-btn-wrapper" }
const _hoisted_158 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_159 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_160 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_161 = { key: 0 }
const _hoisted_162 = { class: "upload-btn-wrapper" }
const _hoisted_163 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_164 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_165 = { class: "my-2" }
const _hoisted_166 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-2" }, null, -1)
const _hoisted_167 = { class: "modal-wrap default-modal" }
const _hoisted_168 = {
  class: "modal fade",
  id: "deleteAcknowledgementInvitationModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_169 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_170 = { class: "modal-content" }
const _hoisted_171 = { class: "modal-header" }
const _hoisted_172 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_173 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_174 = { class: "modal-body" }
const _hoisted_175 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_176 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle mr-2" }, null, -1)
const _hoisted_177 = { class: "form-group" }
const _hoisted_178 = { for: "reasonDecline" }
const _hoisted_179 = { class: "modal-footer" }
const _hoisted_180 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_181 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_182 = { class: "mx-2" }
const _hoisted_183 = { key: 1 }
const _hoisted_184 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_185 = {
  class: "modal fade",
  id: "documentModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_186 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_187 = { class: "modal-content" }
const _hoisted_188 = { class: "modal-header" }
const _hoisted_189 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_190 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_191 = { class: "modal-body" }
const _hoisted_192 = { class: "card contract-desc" }
const _hoisted_193 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_194 = {
  class: "modal fade",
  id: "documentModal1",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_195 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_196 = { class: "modal-content" }
const _hoisted_197 = { class: "modal-header" }
const _hoisted_198 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_199 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_200 = { class: "modal-body" }
const _hoisted_201 = { class: "card contract-desc" }
const _hoisted_202 = { class: "modal-body" }
const _hoisted_203 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-home" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoDetailsAttachment = _resolveComponent("ToDoDetailsAttachment")
  const _component_HistoryTimeLine = _resolveComponent("HistoryTimeLine")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.projectAcknowledgementDetails || _ctx.state.ui.isPostLoading.acknowledgeProject || _ctx.state.ui.isPostLoading.declineProject)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.state.data.acknowledgementDetails && _ctx.state.data.acknowledgementDetails.project && _ctx.state.data.acknowledgementDetails.project.name)
              ? (_openBlock(), _createBlock("h1", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('smart_contract_acknowledgement')) + " " + _toDisplayString(_ctx.state.data.acknowledgementDetails.project.name), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_8, [
              _createVNode("nav", _hoisted_9, [
                _createVNode("ol", _hoisted_10, [
                  _createVNode("li", _hoisted_11, [
                    _createVNode("a", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('home')), 1)
                    ])
                  ]),
                  _createVNode("li", _hoisted_14, [
                    _createVNode("a", _hoisted_15, _toDisplayString(_ctx.$t('projects')), 1)
                  ]),
                  _createVNode("li", _hoisted_16, _toDisplayString(_ctx.$t('smart_contract_acknowledgement_request')), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline d-inline-block me-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectBack && _ctx.redirectBack(...args)))
              }, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.acknowledgementDetails?.smart_contract?.status == 2)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 1,
            hideCloseButton: true,
            showModal: true,
            title: "Contract Signed",
            titleMessage: "This contract has been signed already.",
            isButton: true
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_20, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn mr-2 mb-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToDashboard && _ctx.redirectToDashboard(...args)))
                }, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('go_to_dashboard')), 1)
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn mr-2 mb-2",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToSmartContractList && _ctx.redirectToSmartContractList(...args)))
                }, _toDisplayString(_ctx.$t('go_to_contract')), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.state.data.acknowledgementDetails?.smart_contract?.status !== 2)
        ? (_openBlock(), _createBlock("div", _hoisted_22, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.errors.errorList.phaseAcknowledgementDetails,
              hasError: _ctx.state.ui.errors.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("p", _hoisted_25, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('project_name')) + " : ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.state.data.acknowledgementDetails.project.name), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('payer_email')) + " :", 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("ul", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .acknowledgementDetails.payers, (payer, payerIndex) => {
                      return (_openBlock(), _createBlock("li", { key: payerIndex }, [
                        (payer && payer.first_name)
                          ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(payer.first_name), 1))
                          : _createCommentVNode("", true),
                        _hoisted_28,
                        (payer && payer.email)
                          ? (_openBlock(), _createBlock("span", _hoisted_29, "(" + _toDisplayString(payer.email) + ")", 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("button", {
                    class: "btn default-btn outline orange d-inline-block mb-0 mr-2",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
                  }, [
                    _hoisted_32,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('discussion')), 1)
                  ])
                ]),
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('members')) + " :", 1)
                ]),
                (_ctx.state.data.acknowledgementDetails.payers && _ctx.state.data.acknowledgementDetails.payers.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_33, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.acknowledgementDetails.payers.slice(0, 3), (member, memberIndex) => {
                        return (_openBlock(), _createBlock("a", {
                          href: "javascript:void(0)",
                          key: memberIndex
                        }, [
                          _createVNode("span", null, [
                            _createVNode("img", {
                              src: member.image ? member.image : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`,
                              alt: `${member.first_name}` + '(' + `${member.email}` + ')',
                              title: `${member.first_name}` + '(' + `${member.email}` + ')'
                            }, null, 8, ["src", "alt", "title"])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.state.data.acknowledgementDetails.payers.length > 3)
                        ? (_openBlock(), _createBlock("a", _hoisted_34, [
                            _createVNode("span", _hoisted_35, "+" + _toDisplayString(_ctx.state.data.acknowledgementDetails.payers.length - 3), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode("div", _hoisted_40, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.state.data.acknowledgementDetails.payerRequest.budget), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.calculateProjectTotalDays(_ctx.state.data.sendPhases)) + " days", 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _hoisted_48,
                    (_ctx.state.data.projectTimeline.type == 4)
                      ? (_openBlock(), _createBlock("p", _hoisted_49, [
                          _hoisted_50
                        ]))
                      : (_ctx.state.data.projectTimeline?.start_date && _ctx.state.data.projectTimeline?.end_date)
                        ? (_openBlock(), _createBlock("p", _hoisted_51, [
                            _createVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.state.data.projectTimeline.start_date)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.state.data.projectTimeline.end_date)), 1)
                          ]))
                        : (_openBlock(), _createBlock("p", _hoisted_52, [
                            _hoisted_53
                          ]))
                  ])
                ])
              ])
            ]),
            (_ctx.state.data.acknowledgementDetails.project.details)
              ? (_openBlock(), _createBlock("p", _hoisted_54, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('project_description')) + " :", 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("p", null, [
              _createVNode("small", null, _toDisplayString(_ctx.state.data.acknowledgementDetails.project.details), 1)
            ]),
            (_ctx.state.data.acknowledgementDetails.attachments &&
        _ctx.state.data.acknowledgementDetails.attachments.length)
              ? (_openBlock(), _createBlock("p", _hoisted_55, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('attachments')) + " :", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.attachments &&
        _ctx.state.data.acknowledgementDetails.attachments.length)
              ? (_openBlock(), _createBlock("div", _hoisted_56, [
                  _createVNode("ul", null, [
                    (_ctx.state.data.acknowledgementDetails.attachments &&
            _ctx.state.data.acknowledgementDetails.attachments.length
          )
                      ? (_openBlock(), _createBlock(_component_ToDoDetailsAttachment, {
                          key: 0,
                          todoAttachments: _ctx.state.data.acknowledgementDetails.attachments
                        }, null, 8, ["todoAttachments"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.payerRequest.edoc_id)
              ? (_openBlock(), _createBlock("p", _hoisted_57, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('edoc_link')) + " :", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.payerRequest.edoc_id)
              ? (_openBlock(), _createBlock("p", _hoisted_58, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "link-primary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToDoc && _ctx.redirectToDoc(...args)))
                  }, _toDisplayString(_ctx.state.data.acknowledgementDetails.payerRequest.edoc_id), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_59, [
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('phases')), 1)
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.sendPhases, (phase, phaseIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "border p-3 rounded my-2",
                  key: phaseIndex
                }, [
                  _createVNode("div", _hoisted_60, [
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", {
                        class: "form-check form-check-inline mb-2",
                        onClick: ($event: any) => (_ctx.slectedPhases(phaseIndex))
                      }, [
                        (_ctx.state.data.acknowledgementDetails.payerRequest.individual_approval == 1)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              class: "form-check-input",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (phase.isChecked = $event),
                              disabled: _ctx.state.data.acknowledgementDetails.payerRequest.individual_approval != 1
                            }, null, 8, ["onUpdate:modelValue", "disabled"])), [
                              [_vModelCheckbox, phase.isChecked]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("label", _hoisted_62, _toDisplayString(phase.name), 1)
                      ], 8, ["onClick"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_63, [
                    _createVNode("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("div", _hoisted_67, [
                          _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(phase.budget), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_68, [
                      _createVNode("div", _hoisted_69, [
                        _createVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.getPhaseTotalDays(phase)), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_72, [
                      _createVNode("div", _hoisted_73, [
                        _createVNode("div", _hoisted_74, [
                          _hoisted_75,
                          (phase?.time_line?.type == 4)
                            ? (_openBlock(), _createBlock("p", _hoisted_76, [
                                _hoisted_77
                              ]))
                            : (phase?.time_line?.start_date && phase?.time_line?.end_date)
                              ? (_openBlock(), _createBlock("p", _hoisted_78, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.formatDate(phase.time_line.start_date)) + " - " + _toDisplayString(_ctx.formatDate(phase.time_line.end_date)), 1)
                                ]))
                              : (_openBlock(), _createBlock("p", _hoisted_79, [
                                  _hoisted_80
                                ]))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_81, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('members')) + " :", 1)
                      ]),
                      (phase.payers)
                        ? (_openBlock(), _createBlock("div", _hoisted_82, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.payers, (payer, payerIndex) => {
                              return (_openBlock(), _createBlock("a", {
                                href: "javascript:void(0)",
                                key: payerIndex,
                                class: payer.signature ? '' : 'inactive-member'
                              }, [
                                _createVNode("span", {
                                  class: payer.signature ? 'member-status-wrap active accepted' : 'member-status-wrap active pending'
                                }, [
                                  _createVNode("i", {
                                    class: payer.signature ? 'fas fa-check' : 'fas fa-hourglass-half'
                                  }, null, 2)
                                ], 2),
                                _createVNode("span", null, [
                                  _createVNode("img", {
                                    src: payer.image ? payer.image : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`,
                                    alt: `${payer.first_name}` + '(' + `${payer.email}` + ')',
                                    title: payer.first_name ? `${payer.first_name}` + '(' + `${payer.email}` + ')' : payer.email
                                  }, null, 8, ["src", "alt", "title"])
                                ])
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_83, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_description')) + " : ", 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("small", null, _toDisplayString(phase.description), 1)
                    ])
                  ]),
                  (phase.child_phases || phase.tasks)
                    ? (_openBlock(), _createBlock("div", _hoisted_84, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.child_phases || phase.groupTasks, (task, taskIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "mb-3 border-bottom pb-3",
                            key: taskIndex
                          }, [
                            _createVNode("div", _hoisted_85, [
                              _createVNode("div", _hoisted_86, [
                                _createVNode("div", _hoisted_87, [
                                  _createVNode("label", _hoisted_88, _toDisplayString(task.name), 1)
                                ])
                              ]),
                              (task.allMembers)
                                ? (_openBlock(), _createBlock("div", _hoisted_89, [
                                    _createVNode("div", _hoisted_90, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers, (user, userIndex) => {
                                        return (_openBlock(), _createBlock("a", {
                                          href: "javascript:void(0)",
                                          key: userIndex
                                        }, [
                                          _createVNode("span", null, [
                                            _createVNode("img", {
                                              src: user.image
                          ? user.image
                          : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          ,
                                              alt: "user.email",
                                              title: user.email
                                            }, null, 8, ["src", "title"])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_91, [
                              _createVNode("div", _hoisted_92, [
                                _createVNode("div", _hoisted_93, [
                                  _hoisted_94,
                                  _createVNode("div", _hoisted_95, [
                                    _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(task.budget), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_96, [
                              _createVNode("div", _hoisted_97, [
                                _createVNode("p", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('task_description')) + ":", 1)
                                ]),
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(task.description), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_98, [
                                _createVNode("div", _hoisted_99, [
                                  _createVNode("div", _hoisted_100, [
                                    _hoisted_101,
                                    _createVNode("p", null, [
                                      _createVNode("small", null, _toDisplayString(_ctx.calculateTaskDays(task.time_line)), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              (['2', '3'].includes(task.time_line.type))
                                ? (_openBlock(), _createBlock("div", _hoisted_102, [
                                    _createVNode("div", _hoisted_103, [
                                      _createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "excludeWeekends",
                                        checked: task.time_line.excludeWeekends === 1,
                                        disabled: ""
                                      }, null, 8, ["checked"]),
                                      _hoisted_104
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_105, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_lists')) + " :", 1)
                              ]),
                              (task.items && task.items.length > 0 || task.estimation_items)
                                ? (_openBlock(), _createBlock("div", _hoisted_106, [
                                    _createVNode("div", _hoisted_107, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.items || task.estimation_items, (item, itemIndex) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "card p-1",
                                          key: itemIndex
                                        }, [
                                          _createVNode("div", {
                                            class: "card-header p-0",
                                            id: `heading${itemIndex}${taskIndex}`
                                          }, [
                                            _createVNode("h2", _hoisted_108, [
                                              _createVNode("button", {
                                                class: "btn btn-link text-left shadow-none collapsed",
                                                type: "button",
                                                "data-toggle": "collapse",
                                                "data-target": `#collapse${itemIndex}${taskIndex}`,
                                                "aria-expanded": "true",
                                                "aria-controls": "collapseOne"
                                              }, _toDisplayString(item.name), 9, ["data-target"])
                                            ])
                                          ], 8, ["id"]),
                                          _createVNode("div", {
                                            id: `collapse${itemIndex}${taskIndex}`,
                                            class: "collapse",
                                            "aria-labelledby": "headingOne",
                                            "data-parent": "#accordionExample"
                                          }, [
                                            _createVNode("div", _hoisted_109, [
                                              _createVNode("div", _hoisted_110, [
                                                _createVNode("div", _hoisted_111, [
                                                  _createVNode("p", null, [
                                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('item_name')), 1)
                                                  ]),
                                                  _createVNode("p", null, _toDisplayString(item.name), 1),
                                                  _createVNode("p", null, [
                                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('item_cost')), 1)
                                                  ]),
                                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                                ]),
                                                _createVNode("div", _hoisted_112, [
                                                  _createVNode("p", null, [
                                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('item_description')), 1)
                                                  ]),
                                                  _createVNode("p", null, _toDisplayString(item.description), 1)
                                                ])
                                              ])
                                            ])
                                          ], 8, ["id"])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (phase.attachments &&
            phase.attachments.length
          )
                    ? (_openBlock(), _createBlock("p", _hoisted_113, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_attachments')) + " : ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (phase.attachments &&
            phase.attachments.length
          )
                    ? (_openBlock(), _createBlock("div", _hoisted_114, [
                        _createVNode("div", _hoisted_115, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attachments, (image, imageIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "col-sm-6",
                              key: imageIndex
                            }, [
                              (image.file_type === 'jpg' ||
                  image.file_type === 'png' ||
                  image.file_type === 'jpeg' ||
                  image.file_type === 'gif'
                )
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    class: "shadowed-card bg-white mb-2",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link))
                                  }, [
                                    (image.isuploded)
                                      ? (_openBlock(), _createBlock("div", _hoisted_116, [
                                          _createVNode("span", _hoisted_117, [
                                            _createVNode("span", _hoisted_118, _toDisplayString(_ctx.$t('loading1')), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_119, [
                                      _createVNode("div", _hoisted_120, [
                                        _createVNode("img", {
                                          src: image.file_link,
                                          alt: "",
                                          height: "200"
                                        }, null, 8, ["src"])
                                      ]),
                                      _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                                    ])
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (image.file_type === 'pdf')
                                ? (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    class: "shadowed-card bg-white mb-2",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link))
                                  }, [
                                    (image.isuploded)
                                      ? (_openBlock(), _createBlock("div", _hoisted_121, [
                                          _createVNode("span", _hoisted_122, [
                                            _createVNode("span", _hoisted_123, _toDisplayString(_ctx.$t('loading1')), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_124, [
                                      _createVNode("div", _hoisted_125, [
                                        _createVNode("img", {
                                          src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                          alt: ""
                                        }, null, 8, ["src"])
                                      ]),
                                      _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                                    ])
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (image.file_type === 'doc' || image.file_type === 'docx')
                                ? (_openBlock(), _createBlock("div", {
                                    key: 2,
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link)),
                                    class: "shadowed-card bg-white mb-2"
                                  }, [
                                    (image.isuploded)
                                      ? (_openBlock(), _createBlock("div", _hoisted_126, [
                                          _createVNode("span", _hoisted_127, [
                                            _createVNode("span", _hoisted_128, _toDisplayString(_ctx.$t('loading1')), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_129, [
                                      _hoisted_130,
                                      _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                                    ])
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (image.file_type === 'mp4' ||
                    image.file_type === 'mov' ||
                    image.file_type === 'MOV' ||
                    image.file_type === 'wmv' ||
                    image.file_type === 'webm' ||
                    image.file_type === 'ogg' ||
                    image.file_type === 'avi' ||
                    image.file_type === 'x-ms-wmv'
                  )
                                ? (_openBlock(), _createBlock("div", {
                                    key: 3,
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.handleImageInNewTab(image.file_link)),
                                    class: "media-wrap shadowed-card bg-white mb-2"
                                  }, [
                                    (image.isuploded)
                                      ? (_openBlock(), _createBlock("div", _hoisted_131, [
                                          _createVNode("div", _hoisted_132, [
                                            _createVNode("span", _hoisted_133, [
                                              _createVNode("span", _hoisted_134, _toDisplayString(_ctx.$t('loading1')), 1)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("img", {
                                      src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                      alt: "",
                                      height: "200"
                                    }, null, 8, ["src"]),
                                    _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode("div", _hoisted_135, [
                _createVNode("div", _hoisted_136, [
                  _createVNode("h1", _hoisted_137, _toDisplayString(_ctx.$t('contracts')), 1)
                ]),
                _createVNode("div", _hoisted_138, [
                  _createVNode("div", _hoisted_139, [
                    _createVNode("div", _hoisted_140, [
                      _createVNode("p", _hoisted_141, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                      ]),
                      _createVNode("a", _hoisted_142, _toDisplayString(_ctx.$t('view_details')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_143, [
                    _createVNode("div", _hoisted_144, [
                      _createVNode("p", _hoisted_145, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('legal_statement')), 1)
                      ]),
                      _createVNode("a", _hoisted_146, _toDisplayString(_ctx.$t('view_details')), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_147, [
                _createVNode("ul", null, [
                  _createVNode("li", _hoisted_148, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('senders_signature')), 1)
                    ]),
                    _createVNode("div", _hoisted_149, [
                      _createVNode("img", {
                        src: _ctx.state.data.acknowledgementDetails.payerRequest.signature,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('date')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.acknowledgementDetails.payerRequest.created_at), 1)
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.acknowledgementDetails.approved_signers, (sign, signatureIndx) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "mr-3",
                      key: signatureIndx
                    }, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(sign.first_name ? sign.first_name : sign.email) + " " + _toDisplayString(_ctx.$t('signature')), 1)
                      ]),
                      _createVNode("div", _hoisted_150, [
                        _createVNode("img", {
                          src: sign.signature,
                          alt: `${sign.first_name}` + '(' + `${sign.email}` + ')'
                        }, null, 8, ["src", "alt"])
                      ]),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('date')), 1),
                        _createTextVNode(" " + _toDisplayString(sign.date), 1)
                      ])
                    ]))
                  }), 128)),
                  _createVNode("li", null, [
                    _createVNode("div", _hoisted_151, [
                      _createVNode("label", _hoisted_152, [
                        _createTextVNode(_toDisplayString(_ctx.$t('signature')) + " ", 1),
                        _hoisted_153
                      ]),
                      _createVNode("div", null, [
                        (_ctx.state.data.cropSignature)
                          ? (_openBlock(), _createBlock("div", _hoisted_154, [
                              _createVNode("img", {
                                src: _ctx.state.data.cropSignature,
                                alt: ""
                              }, null, 8, ["src"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("div", _hoisted_155, [
                      _createVNode("div", _hoisted_156, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_157, [
                              _createVNode("button", _hoisted_158, [
                                _hoisted_159,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                              ]),
                              _createVNode("input", {
                                ref: "signatureInput",
                                type: "file",
                                accept: "image/png, image/jpeg",
                                id: "profileUpdate",
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                              }, null, 544)
                            ])
                          ]),
                          _createVNode("li", null, [
                            _createVNode("button", {
                              class: "btn default-btn",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                            }, [
                              _hoisted_160,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                            ])
                          ]),
                          (_ctx.state.data.haveProfileSign)
                            ? (_openBlock(), _createBlock("li", _hoisted_161, [
                                _createVNode("div", _hoisted_162, [
                                  _createVNode("button", {
                                    for: "formFileSm",
                                    class: "btn default-btn mr-2",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.userSignature('use')))
                                  }, [
                                    _hoisted_163,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("li", null, [
                            _createVNode("button", {
                              class: "btn red-btn",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearSignature()))
                            }, _toDisplayString(_ctx.$t('clear')), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_164,
            _createVNode("div", _hoisted_165, [
              _createVNode("button", {
                class: "btn default-btn outline orange d-inline-block mb-0 mr-2",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
              }, [
                _hoisted_166,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('discussion')), 1)
              ]),
              _createVNode("button", {
                type: "submit",
                class: "btn default-btn mr-2",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.acceptEstimation && _ctx.acceptEstimation(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.acknowledgeProject ? _ctx.$t('loading1') : _ctx.$t('acknowledge')), 1),
              _createVNode("button", {
                class: "btn default-btn outline danger d-inline-block mb-0",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showDeclineModal && _ctx.showDeclineModal(...args)))
              }, _toDisplayString(_ctx.$t('decline')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.data.acknowledgementDetails.payerRequest.history && _ctx.state.data.acknowledgementDetails.payerRequest.history.length)
        ? (_openBlock(), _createBlock(_component_HistoryTimeLine, {
            key: 3,
            history: _ctx.state.data.acknowledgementDetails.payerRequest.history
          }, null, 8, ["history"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_167, [
        _createVNode("div", _hoisted_168, [
          _createVNode("div", _hoisted_169, [
            _createVNode("div", _hoisted_170, [
              _createVNode("div", _hoisted_171, [
                _createVNode("h5", _hoisted_172, _toDisplayString(_ctx.$t('invitation_decline')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeAcknowledgementInvitationModal && _ctx.closeAcknowledgementInvitationModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_173
                ])
              ]),
              _createVNode("div", _hoisted_174, [
                _createVNode("div", _hoisted_175, [
                  _hoisted_176,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('decline_invitation_confirmation')), 1)
                ]),
                _createVNode("div", _hoisted_177, [
                  _createVNode("label", _hoisted_178, _toDisplayString(_ctx.$t('reason_to_decline')), 1),
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    id: "description",
                    "aria-describedby": "emailHelp",
                    placeholder: "Provide the Reason for Decline",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.data.acknowledgementDetails.description = $event)),
                    onKeydown: _cache[15] || (_cache[15] = _withKeys(
//@ts-ignore
(...args) => (_ctx.declineProject && _ctx.declineProject(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.state.data.acknowledgementDetails.description]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_179, [
                _createVNode("button", {
                  class: "btn default-btn",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.declineProject && _ctx.declineProject(...args))),
                  disabled: _ctx.state.ui.isPostLoading.declineProject
                ? _ctx.state.ui.isPostLoading.declineProject
                : false
                
                }, [
                  (_ctx.state.ui.isPostLoading.declineProject === true)
                    ? (_openBlock(), _createBlock("span", _hoisted_180, [
                        _hoisted_181,
                        _createVNode("span", _hoisted_182, _toDisplayString(_ctx.$t('loading1')), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_183, _toDisplayString(_ctx.$t('decline')), 1))
                ], 8, ["disabled"]),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeAcknowledgementInvitationModal && _ctx.closeAcknowledgementInvitationModal(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_184, [
        _createVNode("div", _hoisted_185, [
          _createVNode("div", _hoisted_186, [
            _createVNode("div", _hoisted_187, [
              _createVNode("div", _hoisted_188, [
                _createVNode("h5", _hoisted_189, _toDisplayString(_ctx.$t('acknowledgement')), 1),
                _hoisted_190
              ]),
              _createVNode("div", _hoisted_191, [
                _createVNode("div", _hoisted_192, [
                  _createVNode("div", {
                    innerHTML: _ctx.state.data.contract
                  }, null, 8, ["innerHTML"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_193, [
        _createVNode("div", _hoisted_194, [
          _createVNode("div", _hoisted_195, [
            _createVNode("div", _hoisted_196, [
              _createVNode("div", _hoisted_197, [
                _createVNode("h5", _hoisted_198, _toDisplayString(_ctx.$t('legal_statement1')), 1),
                _hoisted_199
              ]),
              _createVNode("div", _hoisted_200, [
                _createVNode("div", _hoisted_201, [
                  _createVNode("div", {
                    innerHTML: _ctx.state.data.leagelDocuments
                  }, null, 8, ["innerHTML"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: true
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_202, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.redirectToDashboard && _ctx.redirectToDashboard(...args)))
              }, [
                _hoisted_203,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('go_to_dashboard')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.redirectToSmartContractList && _ctx.redirectToSmartContractList(...args)))
              }, _toDisplayString(_ctx.$t('go_to_contract')), 1)
            ])
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 1,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 2,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}